import classNames from "classnames/bind";
import { UploadIcon } from "../../../../components/Icons/Icons";
import styles from './Avatar.module.css';
import image from '../../../../assets/images/Rectangle_5676.png';
import { useState } from "react";
import { Loading, Toast } from "../../../../components";
import { formatDates } from "../../../../utils";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import { getAvatarHeader } from "../../../../store/Actions";
import axiosClientUploadFormData from "../../../../services/axiosClientUploadFormData";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);
function Avatar({ infoUser }) {
    const [srcImage, setSrcImage] = useState()
    const [loading, setLoading] = useState(false)
    const [dataStore, dispatch] = useStoreContext();
    const { t } = useTranslation()

    const handleChange = async (e) => {
        if (e.target.files[0].size / (1024 * 1024) < 10) {
            try {
                setLoading(true)
                setSrcImage(e.target.files[0])
                let formDataUser = new FormData();
                for (let [key, value] of Object.entries(infoUser)) {
                    if (key === 'avatar') {
                        formDataUser.append(key, e.target.files[0])
                    } else if (key === 'birthday') {
                        formDataUser.append(key, formatDates(value))
                    } else {
                        formDataUser.append(key, value)
                    }
                }
                await axiosClientUploadFormData.put('/user/put-change-user-info/', formDataUser)
                setLoading(false)
                dispatch(getAvatarHeader(!dataStore.reGetAvatarHeader))
                Toast.open(t("infoUser.change_image_success"), 'success')
                window.location.reload()
            } catch (error) {
                setLoading(false)
                Toast.open(t("infoUser.change_image_error"), 'danger')
                setSrcImage()
            }
        } else {
            Toast.open(t("infoUser.over_size_image"), 'danger')
        }

    }

    return (
        <div className={cx('avatar-user')}>
            <label className={cx('avatar-label')}>{t("infoUser.avatar")}</label>
            <div className={cx('image-container')}>
                {!loading && (<img
                    className={cx('avatar-image')}
                    alt={'avatar'} src={srcImage ?
                        URL.createObjectURL(srcImage) :
                        infoUser?.avatar ?
                            `${process.env.REACT_APP_BASE_URL}${infoUser?.avatar}` : image}
                    accept="image/*"
                    webkitdirectory='true'
                />)}
                {!loading && <label htmlFor="file-upload" className={cx('fill-over', 'custom-file-upload')}>
                    <UploadIcon color={'white'} />
                    <p className={cx('label-upload')}>{t("infoUser.upload_avatar")}</p>
                    <input
                        type="file"
                        name="file-upload"
                        id="file-upload"
                        onChange={handleChange}
                        accept="image/*"
                    />
                </label>}
                {loading && <div className={cx('loading-img')}><Loading /></div>}
            </div>
        </div>
    )
}


export default Avatar;